import React from 'react';

type Props = {
  // 見えるかどうか
  isVisible: boolean;
  // テキスト
  text: string;
};

const DisplayParagraph = React.memo<Props>((props) => (
  <p style={{ display: props.isVisible ? 'block' : 'none' }}>{props.text}</p>
));

export default DisplayParagraph;
